import {api, RequestParam} from "@/shared/api";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Button from "@/shared/utils/button";

export interface SetNoteDialogConfig {
	container: JQuery;
	apiUrl: string;
}

export class SetNoteDialog {

	public static EVENT_NOTE_SET = "noteSet";

	private dialog: BootstrapModal.Modal;
	private params: RequestParam[];
	private noteInput: JQuery;

	constructor(public config: SetNoteDialogConfig) {
		this.init();
	}

	private init() {
		this.noteInput = this.config.container.find("#noteInput");

		this.dialog = new BootstrapModal.Modal({
			message: this.config.container,
			buttons: [{
				text: "setNoteDialog.bulkChangeNote",
				css: "okButton btn-primary",
				action: (modal: BootstrapModal.Modal, button?: JQuery) => {
					this.setNote(button);
				}
			}, {
				text: "dialog.cancel",
				css: "cancelButton btn-default"
			}],
			onClose: () => {
				Button.resetLoading(this.dialog.getButtons("okButton"));
				Button.resetLoading(this.dialog.getButtons("cancelButton"));
				this.noteInput.val("");
			},
			onOpen: () => {
				this.noteInput.focus();
			}
		});
	}

	public show(params: RequestParam[], recordCount: number) {
		this.params = params;

		// Update dialog title with record count
		this.dialog.setTitle(messages.withArguments("setNoteDialog.title", recordCount));

		this.noteInput.val("");
		this.dialog.show();
	}

	private setNote(button?: JQuery) {
		if (this.params) {
			const note = this.noteInput.val() as string;
			this.params.push({name: "note", value: note});

			Button.setLoading(button);
			Button.setLoading(this.dialog.getButtons("cancelButton"));

			api(this.config.apiUrl)
				.post(this.params)
				.done((data) => {
					$(this).triggerHandler(SetNoteDialog.EVENT_NOTE_SET, [data]);
				})
				.always(() => {
					Button.resetLoading(button);
					Button.resetLoading(this.dialog.getButtons("cancelButton"));
					this.dialog.close();
				});
		}
	}
}
